import React, { Component } from "react";
import { withRouter, RouteComponentProps } from "react-router";
import { connect } from "react-redux";
import clsx from "clsx";
import AppStore, { IOrder } from "./StoreContext";
import { withAuth, IAuthProps } from "../../laco-common/auth/AuthContext";
import UILoader from "../ui/UILoader";
import { WidgetProps } from "../widgets";
import { ISubscriptionState, mapSubscriptionStateToProps } from "../../redux/reducers/subscription";
import { ISubscriptionActionDispatches, mapSubscriptionDispatchToProps } from "../../redux/actions/subscription";
import { LOCAL_STORAGE_KEYS } from "../../models/localStorage";
import "./EcwidOverrides.scss";

declare var xProductBrowser: any;
declare var Ecwid: any;
declare var ecwid_onBodyDone: any;
declare var ec: any;
const cartPath: string = "#!/~/cart";

// https://developers.ecwid.com/api-documentation/customize-behaviour#delayed-widget-initialization

// Works only for first load:
// loadScript("https://app.ecwid.com/script.js?16588572&data_platform=code&data_date=2019-02-27", true,
//     function () {
//         xProductBrowser("categoriesPerRow=3", "views=grid(20,3) list(60) table(60)", "categoryView=grid", "searchView=list", "id=my-store-16588572")
//         console.log(xProductBrowser)
//     }
// );

class StorePage extends Component<
	RouteComponentProps & IAuthProps & WidgetProps & ISubscriptionActionDispatches & ISubscriptionState
> {
	private historySub: any;

	state = {
		loading: true,
	};

	componentDidMount() {
		// console.log(this.props)
		AppStore.initStore(undefined, this.onStoreLoaded.bind(this), this.onOrderPlaced.bind(this));

		this.historySub = this.props.history.listen((location, action) => {
			this.routeChanged(location);
		});
		if (this.props.location.hash == cartPath) {
			this.setUserEmailInCart();
		}
	}

	componentWillUnmount() {
		AppStore.destroy();
		this.historySub();

		// xProductBrowser("categoriesPerRow=3", "views=grid(20,3) list(60) table(60)", "categoryView=grid", "searchView=list", "id=my-store-16588572")
	}

	routeChanged(location: { pathname: string; hash: string }) {
		// ec-cart-email-input
		// console.log(location.hash);
		if (location.hash == cartPath) {
			// TODO: also on refresh
			this.setUserEmailInCart();
		}

		// TODO
		if (location.pathname == "/store" && !location.hash) {
			// this.initStore();
			// Ecwid.destroy();
			// ecwid_onBodyDone();
			this.setState({ loading: true });
			// window.location = window.location; // TODO: this is a temporary fix
		}
	}

	setUserEmailInCart() {
		// if (!UserService.user) return;

		// console.log("setUserEmailInCart")

		if (this.props.authContext.userPayload) {
			let interval = setInterval(() => {
				let emailInput: any = document.getElementById("ec-cart-email-input");
				if (emailInput) {
					// emailInput.focus();
					emailInput.value = this.props.authContext.userPayload?.email;
					// console.log(UserService.user);
					// console.log(UserService.authUser)
					// emailInput.blur();

					ec.order = ec.order || {};
					ec.order.extraFields = ec.order.extraFields || {};
					// ec.order.extraFields.userUid = {
					//     'title': 'uid',
					//     'value': UserService.user.uid,
					//     'checkoutDisplaySection': 'pickup_details',
					//     'orderDetailsDisplaySection': 'customer_info'
					// }
					ec.order.extraFields.wrapping_box_signature = {
						title: "How should we sign the package?",
						textPlaceholder: "Package sign",
						type: "text",
						tip: "We will put a label on a box so the recipient knows who it is from",
						required: false,
						checkoutDisplaySection: "shipping_address",
					};

					// console.log(UserService.user)
					// console.log(ec);

					// Ecwid.refreshConfig();

					// console.log(ec);

					clearInterval(interval);
				}
			}, 2000);
		}

		// Initialize extra fields
		// ec.order = ec.order || {};
		// ec.order.extraFields = ec.order.extraFields || {};
		// ec.order.extraFields.uid = UserService.user.uid;

		// console.log(ec)
		// console.log(Ecwid)
	}

	onStoreLoaded() {
		Ecwid.OnPageLoaded.add((page) => {
			this.setState({ loading: false });
			//     if (page.type == "CART") {
			//       // do something ...
			//   }

			// var storeData = Ecwid.getPayload();
			// console.debug(storeData);
			// var storeId = storeData.store_id;
			// console.debug(storeId);
			// var accessToken = storeData.access_token;
			// console.debug(accessToken);
		});
	}

	onOrderPlaced(order: IOrder) {
		console.log("onOrderPlaced:", order);
		// write to orders collection
		this.props.onOrderComplete(order, this.props.authContext, true);

		// check if in items there is an id that is in forms sku, find form submission and set to paid
		const formId: string = localStorage.getItem(LOCAL_STORAGE_KEYS.STORE_FORM_ID);
		if (formId) {
			this.props.updateFormSubmissionToPaid(order, formId, this.props.authContext);
			localStorage.setItem(LOCAL_STORAGE_KEYS.STORE_FORM_ID, "");
		}
	}

	render() {
		return (
			// <Page className="e-shopping-cart" transitionName="page-fade-in">
			<div className={clsx("container ecwid-overrides", !this.props.isNested && "section-padding pb-3")}>
				<UILoader display={this.state.loading} />
				<div id={`my-store-${process.env.REACT_APP_ECWID_STORE_ID}`}></div>

				{/* <div id="my-store-16588572"></div>
                    <div id="my-categories-16588572"></div>
                    <div id="my-search-16588572"></div>
                    <div className="ec-cart-widget"></div> */}
			</div>
		);
	}
}

export default connect<ISubscriptionState, ISubscriptionActionDispatches>(
	mapSubscriptionStateToProps,
	mapSubscriptionDispatchToProps
)(withAuth(withRouter(StorePage)));
